const e = {
  name: "PlusMedium",
  dimensions: { width: 12, height: 13 },
  content: `
    <svg fill="currentColor">
        <path d="M5 7.5V12.5H7V7.5H12V5.5H7V0.5H5V5.5H0V7.5H5Z" fill="currentColor"/>
    </svg>
  `
};
export {
  e as PlusMedium
};
